import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { incidentDetailRouteRef, incidentsRouteRef } from './routes';

const incidentsPage = PageBlueprint.make({
  name: 'incidents',
  params: {
    path: '/incidents',
    routeRef: incidentsRouteRef,
    title: 'Incidents',
    icon: <ReportProblemOutlinedIcon />,
    loader: () => import('./IncidentsPage').then(m => <m.IncidentsPage />),
  },
});

/*
 * A sibling top-level page, not a sub-page — see `routes.ts`. No `title` or
 * `icon`: those feed the sidebar, and a parameterised route has no single
 * destination to offer there.
 */
const incidentDetailPage = PageBlueprint.make({
  name: 'incident-detail',
  params: {
    path: '/incidents/:incidentId',
    routeRef: incidentDetailRouteRef,
    loader: () =>
      import('./IncidentDetailPage').then(m => <m.IncidentDetailPage />),
  },
});

export const incidentsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [incidentsPage, incidentDetailPage],
});
